module.exports = __webpack_public_path__ + "img/warabee_top2.fd456348.jpg";